const currentDate: Date = new Date();
export const currentMonth: any = currentDate.getMonth();
export const platformKeys: { [key: string]: string } = {
  iOS: "iOS",
  android: "android",
  web: "web",
  desktop: "studio",
};
